var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkChartStyleKagi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28585 0.857143H5.00014V7.71429H7.85728V2.57143H9.57157V10H10.143V2H7.28585V7.14286H5.57157V0.285714H2.71443V10.5714H1.00014V7.71429H0.428711V11.1429H3.28585V0.857143Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkChartStyleKagi);
export default __webpack_public_path__ + "static/media/dark-chart-style-kagi.5e0acd3ec7b7bfb351a3a695889f5f0e.svg";
export { ForwardRef as ReactComponent };